module.exports = __webpack_public_path__ + "img/powered-by-google.60e8a832.png";